import { BannerWrap } from "./Banner.style";
const Banner = () => {
    return (
        <BannerWrap>
            <button className="more-btn">더보기</button>
        </BannerWrap>
    );
};

export default Banner;
